import React, { useContext, useEffect, useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Box, Flex, NotificationBadge, TextButton } from "@catchoftheday/cg-components";
import { CatalogueContext } from "../../../contexts/CatalogueContext.jsx";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var FacetAccordion = function FacetAccordion(_ref) {
  var id = _ref.id,
      displayName = _ref.displayName,
      totalApplied = _ref.totalApplied,
      showMore = _ref.showMore,
      children = _ref.children;

  var _useContext = useContext(CatalogueContext),
      removeFilterKey = _useContext.removeFilterKey;

  var _useState = useState(true),
      expanded = _useState[0],
      setExpanded = _useState[1];

  var _useState2 = useState(),
      maxHeight = _useState2[0],
      setMaxHeight = _useState2[1];

  useEffect(function () {
    if (showMore && expanded) {
      setMaxHeight("unset");
      return;
    }

    if (!expanded) {
      setMaxHeight("0px");
      return;
    }

    setMaxHeight(undefined);
  }, [showMore, expanded]);
  return ___EmotionJSX(Box, {
    mb: 2
  }, ___EmotionJSX(Accordion, {
    showDividerTop: false,
    showDividerBottom: false,
    backgroundColor: "white",
    expanded: expanded,
    onChange: function onChange() {
      return setExpanded(function (val) {
        return !val;
      });
    }
  }, ___EmotionJSX(AccordionSummary, {
    py: 4
  }, ___EmotionJSX(Flex, null, ___EmotionJSX(Box, {
    flexGrow: 1
  }, displayName), totalApplied > 0 && ___EmotionJSX(React.Fragment, null, ___EmotionJSX(TextButton, {
    fontSize: "xs",
    pr: 10,
    onClick: function onClick(e) {
      e.stopPropagation();
      removeFilterKey("f.".concat(id));
    },
    opacity: expanded ? 1 : 0
  }, "Clear"), " ", ___EmotionJSX(NotificationBadge, {
    text: totalApplied,
    top: 0,
    absRight: "25px",
    position: "relative",
    height: "20px",
    backgroundColor: "secondary"
  })))), ___EmotionJSX(AccordionDetails, {
    CollapsibleProps: maxHeight ? {
      maxHeight: maxHeight
    } : {}
  }, children)));
};